import {Paper, Link} from '@mui/material';

import eLibraryDocument from '../../../types/legal/eLibraryDocument';
import agencyAction from '../../../types/legal/agencyAction';
import PressRelease from '../../../types/communication/pressRelease';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


enum AgencyActionsEnums{
  PublicResolutionLetter = 1,
  DispositionAgreement = 2,
  NonFilerReferral = 3,
  AGO = 4,
}



interface Props {
  eLibraryDocuments?: eLibraryDocument[];
  agencyActions?: agencyAction[];
  PressReleases?: PressRelease[];
}

const LegalTable = (props: Props): JSX.Element => {

  return (
    <>
    {(props.eLibraryDocuments && props.eLibraryDocuments.length > 0 || props.agencyActions &&  props.agencyActions.length > 0 || props.PressReleases && props.PressReleases.length > 0 )    && 
    
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="Table for legal e library information">
        <TableHead>
          <TableRow >
            {props.eLibraryDocuments && <TableCell align='left' sx={{fontWeight: 'bold'}}>Link</TableCell>}
            {props.eLibraryDocuments &&<TableCell align='left'  sx={{fontWeight: 'bold'}}>Description</TableCell>}

            {props.agencyActions && <TableCell align='left' sx={{fontWeight: 'bold'}}>Subject</TableCell>}
            {props.agencyActions && props.agencyActions[0].actionTypeId === AgencyActionsEnums.PublicResolutionLetter && <TableCell align='left' sx={{fontWeight: 'bold'}}>Resolution Date</TableCell>}
            {props.agencyActions && props.agencyActions[0].actionTypeId === AgencyActionsEnums.DispositionAgreement && <TableCell colSpan={2} align='left' sx={{fontWeight: 'bold'}}>Resolution Documents</TableCell>}
            {props.agencyActions && props.agencyActions[0].actionTypeId === AgencyActionsEnums.NonFilerReferral && <TableCell align='left' sx={{fontWeight: 'bold'}}>Date</TableCell>}
            {props.agencyActions && props.agencyActions[0].actionTypeId === AgencyActionsEnums.AGO && <TableCell align='left' sx={{fontWeight: 'bold'}}>View Press Release</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
            {props.eLibraryDocuments && props.eLibraryDocuments.map((document, index) => (
              <TableRow key={document.id} sx={{
                '&:hover': {
                  backgroundColor: 'grey.100',
                  transition: 'background-color 0.3s ease',
                }
              }}>
                <TableCell 
                  sx={{whiteSpace: 'nowrap', overflow: 'hidden',textOverflow: 'ellipsis'}} >
                  <Link href={'https://ocpf2.blob.core.windows.net/pdf/legaldocs/'+document.pdfFileName + '.pdf'} target="_blank">{document.pdfFileName}</Link></TableCell>
                <TableCell>
                  {document.title ? <><strong>{document.title}</strong><br /></>: ''}
                  <span dangerouslySetInnerHTML={{ __html: document.description ?? '' }}></span>
                </TableCell>
              </TableRow>
            ))
            }
             {props.agencyActions && props.agencyActions.map((document, index) => (
              <TableRow key={document.id}>
                <TableCell>{document.subject}</TableCell>
                {document.actionTypeId == AgencyActionsEnums.PublicResolutionLetter && <TableCell><Link href={'https://ocpf2.blob.core.windows.net/pdf/actions/'+document.agreementPdfFileName + '.pdf'} target="_blank">{document.resolutionDate}</Link></TableCell>}

                {document.actionTypeId == AgencyActionsEnums.DispositionAgreement && 
                  <TableCell><Link href={'https://ocpf2.blob.core.windows.net/pdf/actions/'+document.agreementPdfFileName + '.pdf'} target="_blank">{document.resolutionDate}</Link></TableCell>
                }
                {document.actionTypeId == AgencyActionsEnums.NonFilerReferral && <TableCell><Link href={'https://ocpf2.blob.core.windows.net/pdf/actions/'+document.agreementPdfFileName + '.pdf'} target="_blank">{document.resolutionDate}</Link></TableCell>}
                {document.actionTypeId == AgencyActionsEnums.AGO && <TableCell><Link href={'https://ocpf2.blob.core.windows.net/pdf/releases/'+document.prPdfFileName + '.pdf'} target="_blank">{document.resolutionDate}</Link></TableCell>}
              </TableRow>
            ))
            }

            {
              props.PressReleases && props.PressReleases.map((document, index) => (
                <TableRow key={document.id}>
                  <TableCell><Link href={'https://ocpf2.blob.core.windows.net/pdf/releases/'+document.pdfFileName + '.pdf'} target="_blank">{document.date}</Link></TableCell>
                  <TableCell>{document.name}</TableCell>
                </TableRow>
              ))
            }
        </TableBody>
      </Table>
    </TableContainer>}
  </>
  );
};

export default LegalTable;